module.exports = __webpack_public_path__ + "static/img/nodata.64be72f2.jpg";